import React, { useState, useEffect } from "react";

const roles = [
  "d'un accès à une base de candidats qualifiés",
  "d'une Rémunération à la mission ou au placement",
  "d'une Liberté d'organisation",
  "d'un partenariat avec une agence reconnue",
  "d'outils digitaux mis à disposition",
  "d'un support administratif assuré",
  "d'un accès à des clients PME et grands comptes",
  "d'un suivi et accompagnement personnalisés",
];

export default function TypingSection() {
  const [currentRoleIndex, setCurrentRoleIndex] = useState(0);
  const [displayText, setDisplayText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [speed, setSpeed] = useState(100);

  useEffect(() => {
    const fullText = roles[currentRoleIndex];

    const handleTyping = () => {
      if (!isDeleting) {
        // Add one character
        setDisplayText(fullText.substring(0, displayText.length + 1));
        setSpeed(150);

        // When complete, start deleting after a pause
        if (displayText.length + 1 === fullText.length) {
          setTimeout(() => setIsDeleting(true), 1000);
        }
      } else {
        // Remove one character
        setDisplayText(fullText.substring(0, displayText.length - 1));
        setSpeed(50);

        // When fully deleted, move to next role
        if (displayText.length - 1 === 0) {
          setIsDeleting(false);
          setCurrentRoleIndex((prev) => (prev + 1) % roles.length);
        }
      }
    };

    const timer = setTimeout(handleTyping, speed);
    return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [displayText, isDeleting, roles, currentRoleIndex, speed]);

  return (
    <section className="bg-white py-20">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl font-bold text-gray-900">
          En tant que freelance, vous bénéficiez{" "}
          <span className="text-blue-600">
            {displayText}
            <span className="blinking-cursor">|</span>
          </span>
        </h2>
      </div>
      <style jsx="true">{`
        .blinking-cursor {
          display: inline-block;
          margin-left: 2px;
          width: 1px;
          background-color: currentColor;
          animation: blink 1s step-end infinite;
        }
        @keyframes blink {
          from,
          to {
            background-color: transparent;
          }
          50% {
            background-color: currentColor;
          }
        }
      `}</style>
    </section>
  );
}
